import { useState } from 'react';

const useTextSelection = () => {
  const [isTextSelected, setIsTextSelected] = useState(false);

  const handleTextSelection = (e) => {
    const input = e.target;
    const isSelected = input?.selectionStart !== input?.selectionEnd;
    setIsTextSelected(isSelected);
  };

  return { isTextSelected, handleTextSelection, setIsTextSelected };
};

export default useTextSelection;
